import { useContext } from "react";
import config from "../../config";
import { useQuery } from "@tanstack/react-query";
import { AppContext } from "@/App.context";
import {
  API_LOADING_ERROR,
  API_NO_DATA_FOUND_ERROR,
  API_NOT_FOUND_ERROR,
  ERROR_STATUS_CODES,
} from "@/lib/errors/error-constants";

/**
 * @typedef GetAllStatisticsReq
 * @property {'aws' | 'gcp' | 'azure' | 'allclouds' } service
 */

export const getAllReporting = (token) => {
  /**
   * @param {GetAllStatisticsReq} req
   * @param {AbortSignal=} signal
   * @returns {Promise<GetAllStatisticsRes>}
   */

  return async (
    { service, page, recordsPerPage, type, group_by, frequency, period },
    signal
  ) => {
    const body = {
      group_by: group_by || [],
      frequency: frequency || [],
      period_range: period || [],
    };
    const statistics = await fetch(
      `${config.reportApiHost}/v1/${service}/reporting/${type}?page=${page}&record_per_page=${recordsPerPage}&order_by=axy&desc=true`,
      {
        method: "POST",
        body: JSON.stringify(body),
        signal,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    if (!statistics.ok) {
      if (ERROR_STATUS_CODES.includes(statistics.status)) {
        throw new Error(API_LOADING_ERROR);
      }
      if (statistics.status === 404) {
        throw new Error(API_NOT_FOUND_ERROR);
      }
      throw new Error((await statistics.json()).message);
    }
    const res = await statistics.json();
    if (res?.data?.reports?.length === 0) {
      throw new Error(API_NO_DATA_FOUND_ERROR);
    }

    return res;
  };
};

/**
 * @param {GetAllStatisticsReq} req
 * @param {any[]=} deps
 */
export const useReportingTableData = (req, deps = []) => {
  const appContext = useContext(AppContext);
  const query = useQuery({
    queryKey: ["getAllReporting", req, ...deps],
    queryFn: ({ signal }) => getAllReporting(appContext.idToken)(req, signal),
  });
  return query;
};
